import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.125.75h-8.25a3 3 0 0 0-3 3v16.5a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3V3.75a3 3 0 0 0-3-3"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M12 3.775a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5"
    }, null, -1)
  ]));
}
const computerDeviceMobilePhoneAndroidSamsung = { render };
export {
  computerDeviceMobilePhoneAndroidSamsung as default,
  render
};
//# sourceMappingURL=computer-device-mobile-phone-android-samsung.svg.js.map
